import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface BloodDonorParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface BloodDonor {
    id?: any;
    bbDonorName?:string;
    bbDonorAge?:number;
    bbDonorDob?:Date;
    bbDonorBloodGroup?:string;
     bbAadharNo?:string;
    bbMobileNo?:string;
    bbEmail?:string;
    bbAltContactType1?:string;
    bbAltContactMobile1?: string;
    bbAltContactType2?:string;
    bbAltContactMobile2?:string;
    bbAltContactName1?:string;
    bbAltContactName2?:string;
     bbDonorAddress1?:string;
    bbDonorAddress2?:string;
    bbDonorCity?:string;
    bbDonorCommFlag?:string;
    bbDonorPreference?:string;
    bbDonorPincode?:string;
    bbIsDonorFrom?:string;
    bbIsDonorId?:string;
    gender?:string;
    bbLastdateOfDonation?:Date;
    createdDate?:Date;
     updatedDate?:Date;
     createdBy?:number;
    updatedBy?: number;
    createdIP?:string;
    updatedIP?:string;
    bbDonorDistrict?:any;
    bbDonorState?:any;
    tenantId:any;
    branchId:any;
    parameters?: BloodDonorParameter[];
    links?: any;
    donorNo:any;
    donorType:any;
    permDeferredFlag:any;
    tempDeferredFlag:any;
}


export abstract class BloodDonorData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<any[]>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract create(url: string, data: any): Observable<any[]>;
    abstract update(url: string, data: any): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
